import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  height: 80vh;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/images/backround_index.jpg') no-repeat center center/cover;
  display: flex;
  align-items: center;
  text-align: center;
  color: white;
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  h1 {
    font-size: 3rem;
    margin-bottom: 20px;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
  
  p {
    font-size: 1.2rem;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
`;

const Button = styled.a`
  display: inline-block;
  background-color: var(--accent-color);
  color: var(--dark-color);
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: #e0a800;
    transform: translateY(-3px);
  }
`;

function Hero() {
  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('kontakt');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <HeroSection className="hero">
      <div className="container">
        <HeroContent className="hero-content">
          <h1>Sicherheit, Taxi & Reinigung in Berlin | GuardiansMoves</h1>
          <p>
            Wir bieten professionelle Dienstleistungen in den Bereichen Sicherheit, Taxi- und Mietwagenservice, Reinigung sowie berufliche Weiterbildung in Berlin und Umgebung -- zuverlässig, hochwertig und kundenorientiert. 24/7 für Sie da!
          </p>
          <Button href="#kontakt" onClick={scrollToContact} className="btn">Jetzt anfragen</Button>
        </HeroContent>
      </div>
    </HeroSection>
  );
}

export default Hero;